export default "/static/dashboard/build/app/img/v2/18e0996b0f79edcbefe8f062db7e0282.png";